<template>
  <div class="min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-nunito">
    <!-- Container principal -->
    <div class="w-full max-w-lg">
      <!-- Logo -->
      <div class="flex items-center justify-center mb-8">
        <img src="@/assets/bot_express_logo.png" alt="Logo" class="h-auto w-[180px] sm:w-[280px]">
      </div>

      <!-- Card de login -->
      <div class="bg-white/5 rounded-xl overflow-hidden">
        <div class="p-6 sm:p-8">
          <!-- Cabeçalho -->
          <div class="mb-8">
            <h2 class="text-white text-2xl font-bold mb-2">Bem-vindo de volta</h2>
            <p class="text-[#888888]">Acesse sua conta para continuar</p>
          </div>

          <!-- Formulário -->
          <form @submit.prevent="handleLogin" class="space-y-5">
            <!-- Email -->
            <div class="space-y-2">
              <label for="email" class="block text-sm font-medium text-[#AAAAAA]">Email</label>
              <div class="relative">
                <input 
                  id="email" 
                  v-model="email" 
                  type="email" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="seu@email.com"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-[#555555]">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Senha -->
            <div class="space-y-2">
              <div class="flex items-center justify-between">
                <label for="password" class="block text-sm font-medium text-[#AAAAAA]">Senha</label>
                <RouterLink to="/password-recovery" class="text-xs font-medium text-[#10B981] hover:text-[#0EA271] transition-colors">
                  Esqueceu a senha?
                </RouterLink>
              </div>
              <div class="relative">
                <input 
                  id="password" 
                  v-model="password" 
                  :type="showPassword ? 'text' : 'password'" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="••••••••"
                />
                <button 
                  type="button" 
                  @click="showPassword = !showPassword" 
                  class="absolute inset-y-0 right-0 flex items-center pr-3 text-[#555555] hover:text-[#AAAAAA] transition-colors"
                >
                  <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Lembrar-me -->
            <div class="flex items-center">
              <Switch v-model="remember" />
              <label for="remember" class="ml-2 text-sm text-[#AAAAAA] cursor-pointer">Lembrar-me</label>
            </div>

            <!-- Botão de login -->
            <button 
              type="submit" 
              class="w-full py-3 px-4 bg-[#10B981] hover:bg-[#0EA271] text-white font-medium rounded-md transition-colors duration-200 flex items-center justify-center"
              :disabled="!email || !password || isLoading"
              :class="{
                'opacity-50 cursor-not-allowed pointer-events-none': !email || !password || isLoading
              }"
            >
              <Loader2 v-if="isLoading" class="w-4 h-4 animate-spin mr-2" />
              <span>Entrar</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                <polyline points="10 17 15 12 10 7"></polyline>
                <line x1="15" x2="3" y1="12" y2="12"></line>
              </svg>
            </button>
          </form>

          <!-- Separador -->
          <!-- <div class="relative my-8">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-[#333333]"></div>
            </div>
            <div class="relative flex justify-center text-xs">
              <span class="px-2 bg-[#141414] text-[#888888]">ou continue com</span>
            </div>
          </div> -->

          <!-- Botões de login social -->
          <!-- <div class="grid grid-cols-2 gap-3">
            <button 
              type="button" 
              class="flex items-center justify-center px-4 py-2.5 rounded-md bg-white/5 hover:bg-[#222222] text-white text-sm font-medium transition-colors"
            >
              <svg class="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z" fill="#FFF"></path>
              </svg>
              Google
            </button>
            <button 
              type="button" 
              class="flex items-center justify-center px-4 py-2.5 rounded-md bg-white/5 hover:bg-[#222222] text-white text-sm font-medium transition-colors"
            >
              <svg class="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.05 2.997c-.3.134-2.434 1.454-4.1 3.325-3.8 4.27-1.234 7.27-.834 7.737.834.935 2.434 1.068 2.434 1.068s.3 1.735-1 2.536c-1.167.668-2 .668-2.667.4-.667-.267-3.3-1.334-4.767-4.27-1.466-2.936-.766-6.204 1.334-8.205 2.1-2 4.433-2.402 5.766-2.402 1.334 0 3.834.534 3.834.534v-.723z" fill="#229ED9"></path>
                <path d="M10.983 8.27l-7.95 3.003c-.834.334-.834 1.068-.834 1.068L8.65 14.34s.3.134.3 0c0-.134 1.334-8.472 1.334-8.472s.1-.668.3-.668c.2 0 .4.267.4.267v2.803z" fill="#229ED9"></path>
                <path d="M10.983 8.27l-7.95 3.003c-.834.334-.834 1.068-.834 1.068L8.65 14.34s.3.134.3 0c0-.134 1.334-8.472 1.334-8.472s.1-.668.3-.668c.2 0 .4.267.4.267v2.803z" fill="#229ED9"></path>
                <path d="M8.65 14.34l-1.334 5.003s-.1.534-.5.534c-.4 0-3.3-2.536-3.3-2.536s-.3-.267-.3-.534c0-.267.3-.4.3-.4l5.134-2.068z" fill="#229ED9"></path>
                <path d="M8.65 14.34l-1.334 5.003s-.1.534-.5.534c-.4 0-3.3-2.536-3.3-2.536s-.3-.267-.3-.534c0-.267.3-.4.3-.4l5.134-2.068z" fill="#229ED9"></path>
                <path d="M8.65 14.34l3.3 2.402s.334.267.334.534c0 .267-.434.334-.434.334l-4.534 1.735s-.3.134-.5.134h-.5L8.65 14.34z" fill="#229ED9"></path>
              </svg>
              Telegram
            </button>
          </div> -->

          <!-- Link para criar conta -->
          <div class="mt-8 text-center">
            <p class="text-[#888888] text-sm">
              Não tem uma conta?
              <RouterLink to="/register" class="text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors">
                Criar agora
              </RouterLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toaster />
</template>

<script setup lang="ts">
import { Switch } from '@/components/ui/switch'
import { Toaster } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import { Loader2 } from 'lucide-vue-next'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// Estado do formulário
const router = useRouter()
const { login } = useAuth()
const email = ref('')
const password = ref('')
const remember = ref(false)
const showPassword = ref(false)
const isLoading = ref(false)

// Função de login
const handleLogin = async () => {
  isLoading.value = true
  try {
    const response = await login({ 
      email: email.value, 
      password: password.value, 
    })

    // Check if 2FA is required
    if (response.is2AF) {
      router.push({ name: '2fa' })
      return
    }

    router.push({ name: 'organizations' })
  } catch (error) {
    email.value = ''
    password.value = ''
  } finally {
    isLoading.value = false
  }
}
</script>